import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Icon from "@/components/icons/Icon/Icon.vue";
import { ActionButtonType } from "@/types/button";
import { IconType } from "@/types/icons";

interface Props {
  actionType: ActionButtonType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RingingCallIcon',
  props: {
    actionType: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ringingCallIcon", _ctx.actionType])
  }, [
    _createVNode(Icon, {
      icon: _unref(IconType).INCOMING_CALL
    }, null, 8, ["icon"])
  ], 2))
}
}

})